module.exports = __webpack_public_path__ + "img/03生产智能控制.2a498aff.jpg";